/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { withStyles } from '@material-ui/core';
import React, { useState, useMemo } from 'react';
import Spinner from 'modules/common/spinner.component';
import AddressAutocompleteSection from 'modules/authorizations/details/addressManagementCrudTable.component';
import { compose } from 'recompose';
import AdvancedSearch from 'modules/common/advancedSearch.component';

const styles = theme => ({
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important',
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important',
  },
  editModalInput: {
    minWidth: '332px',
  },
  dialogContentContainer: {
    margin: '15px',
  }
});

const chunkColumns = (columns, chunkSize) => {
  const rows = [];
  for (let i = 0; i < columns.length; i += chunkSize) {
    rows.push(columns.slice(i, i + chunkSize));
  }
  return rows;
};

// Edit Modal for Client Contacts with Google Places Integration
const ClientContactsEditRecordModal = ({ open, classes, columns, onClose, row, onSubmit, hideEdit, isLoading, countriesEnum, provincesEnum }) => {
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = row.getValue(column.accessorKey);
      return acc;
    }, {}),
  );

  const [originalValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = row.getValue(column.accessorKey);
      return acc;
    }, {}),
  );

  // Check if form is dirty (has changes)
  const isDirty = useMemo(() => {
    return Object.keys(values).some(key => values[key] !== originalValues[key]);
  }, [values, originalValues]);

  const renderInput = (column) => {
    if (column?.hideInModel === true || (column.shouldHideField != null && column.shouldHideField(values))) {
      return null;
    }
    if (column.type === 'text') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey] || ''}
            disabled={column.accessorKey === 'fieldId' ? values[column.accessorKey]?.length > 0 : column.disabled}
            margin="dense"
            variant="standard"
            sx={{ width: '360px' }}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'checkbox') {
      return (
        <div>
          <FormControlLabel
            control={
              <Checkbox
                key={column.accessorKey}
                name={column.accessorKey}
                checked={values[column.accessorKey] || false}
                onChange={(e) => setValues({ ...values, [e.target.name]: e.target.checked })}
              />
            }
            label={column.header}
          />
        </div>
      );
    }
    if (column.type === 'dropdown-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              variant="standard"
              required={column.required}
              sx={{ width: '360px' }}
              value={values[column.accessorKey] || ''}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'advanced-search') {
          const searchValues = column.searchInfo.searchingRows;
          let nameKey = '';
          if (searchValues) {
            const selectedValue = searchValues.find((s) => s[column.accessorKey] === values[column.accessorKey]);
            if (selectedValue) {
              nameKey = selectedValue[column.nameKey];
            }
          }
          return (
            <div>
            <FormControl sx={{ marginTop: '6px', width: '100%'  }}>
              <AdvancedSearch
                labelText={column.header}
                displayValueAccessorKey={column.searchInfo.nameKey}
                saveIdValueAccessorKey={column.searchInfo.idKey}
                searchingCriteria={column.searchInfo.searchingColumns}
                searchingCriteriaExtensions={column.searchInfo.searchingColumnExtensions}
                searchingRows={column.searchInfo.searchingRows}
                id={values[column.accessorKey]}
                value={nameKey}
                setIdValue={(id, value) => {
                  setValues({ ...values, [column.nameKey]: value, [column.accessorKey]: id });
                }}
                maxWidthsx={'360px'}
                variant="standard"
              />
            </FormControl>
            {column.required && (
                <>
                  <Typography variant="caption" display="block" color="primary">
                    Required
                  </Typography>
                </>
              )}
            </div>
          );
        }
    if (column.type === 'multi-select-v2') {
      // Ensure value is always an array
      const selectedValues = Array.isArray(values[column.accessorKey]) 
        ? values[column.accessorKey] 
        : [];
      
      // Extract IDs for the select component - handle both {id, title} and {clientDivisionId} formats
      const selectedIds = selectedValues.map(v => v.id || v.clientDivisionId).filter(Boolean);
      
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              variant="standard"
              required={column.required}
              multiple
              sx={{ width: '360px' }}
              value={selectedIds}
              onChange={(e) => {
                // Convert selected IDs back to objects with id/title format
                const selectedObjects = e.target.value.map(id => 
                  column.options.find(opt => opt.id === id)
                ).filter(Boolean);
                setValues({ ...values, [e.target.name]: selectedObjects });
              }}
            >
              {column.options.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    return null;
  };

  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(values, row);
  };

  const chunkedColumns = chunkColumns(columns, 3);

  return (
    <Dialog open={open} fullWidth maxWidth="lg">
      <Box sx={{ padding: 3 }}>
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          Edit Contact
        </Typography>
        
        {/* Google Places Address Search Section */}
        <AddressAutocompleteSection
          values={values}
          setValues={setValues}
          countriesEnum={countriesEnum}
          provincesEnum={provincesEnum}
        />

        {/* Manual Input Fields */}
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem',
            }}
          >
            <Grid container spacing={{ xs: 1, md: 1 }} sx={{ padding: '30px', paddingTop: '0px' }}>
              {chunkedColumns.map((columnChunk, rowIndex) => (
                <Grid container item spacing={2} key={rowIndex}>
                  {columnChunk.map((column, colIndex) => {
                    if(column.dependentOn && values[column.dependentOn] === column.dependentValue)
                    {
                      return (
                        <Grid item xs={4} key={column.accessorKey}>
                          {renderInput(column, rowIndex * colIndex)}
                        </Grid>
                      );
                    }
                    else {
                      return (
                        <Grid item xs={4} key={column.accessorKey}>
                          {renderInput(column, rowIndex * colIndex)}
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              ))}
            </Grid>
          </Stack>
        </div>
      </Box>
      {isLoading && (
        <DialogActions sx={{ p: '1.25rem' }}>
          <Spinner />
        </DialogActions>
      )}
      {!isLoading && (
        <DialogActions sx={{ p: '1.25rem' }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button color="primary" onClick={handleSubmit} variant="contained" disabled={!isDirty}>
            Save
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

// Create Modal for Client Contacts with Google Places Integration
const ClientContactsCreateRecordModal = ({ open, classes, columns, onClose, onSubmit, hideEdit, isLoading, countriesEnum, provincesEnum }) => {
  const [values, setValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = '';
      return acc;
    }, {}),
  );

  const [originalValues] = useState(() =>
    columns.reduce((acc, column) => {
      acc[column.accessorKey ?? ''] = '';
      return acc;
    }, {}),
  );

  // Check if form is dirty (has changes)
  const isDirty = useMemo(() => {
    return Object.keys(values).some(key => values[key] !== originalValues[key]);
  }, [values, originalValues]);

  const renderInput = (column) => {
    if (column?.hideInModel === true || (column.shouldHideField != null && column.shouldHideField(values))) {
      return null;
    }
    if (column.type === 'text') {
      return (
        <div>
          <TextField
            key={column.accessorKey}
            label={column.header}
            name={column.accessorKey}
            required={column.required}
            value={values[column.accessorKey] || ''}
            disabled={column.disabled}
            margin="dense"
            variant="standard"
            sx={{ width: '360px' }}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'checkbox') {
      return (
        <div>
          <FormControlLabel
            control={
              <Checkbox
                key={column.accessorKey}
                name={column.accessorKey}
                checked={values[column.accessorKey] || false}
                onChange={(e) => setValues({ ...values, [e.target.name]: e.target.checked })}
              />
            }
            label={column.header}
          />
        </div>
      );
    }
    if (column.type === 'dropdown-v2') {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              variant="standard"
              required={column.required}
              sx={{ width: '360px' }}
              value={values[column.accessorKey] || ''}
              onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {column.options.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (column.type === 'advanced-search') {
          const searchValues = column.searchInfo.searchingRows;
          let nameKey = '';
          if (searchValues) {
            const selectedValue = searchValues.find((s) => s[column.accessorKey] === values[column.accessorKey]);
            if (selectedValue) {
              nameKey = selectedValue[column.nameKey];
            }
          }
          return (
            <div>
            <FormControl sx={{ marginTop: '6px', width: '100%'  }}>
              <AdvancedSearch
                labelText={column.header}
                displayValueAccessorKey={column.searchInfo.nameKey}
                saveIdValueAccessorKey={column.searchInfo.idKey}
                searchingCriteria={column.searchInfo.searchingColumns}
                searchingCriteriaExtensions={column.searchInfo.searchingColumnExtensions}
                searchingRows={column.searchInfo.searchingRows}
                id={values[column.accessorKey]}
                value={nameKey}
                setIdValue={(id, value) => {
                  setValues({ ...values, [column.nameKey]: value, [column.accessorKey]: id });
                }}
                maxWidthsx={'360px'}
                variant="standard"
              />
            </FormControl>
            {column.required && (
                <>
                  <Typography variant="caption" display="block" color="primary">
                    Required
                  </Typography>
                </>
              )}
            </div>
          );
        }
    if (column.type === 'multi-select-v2') {
      // Ensure value is always an array
      const selectedValues = Array.isArray(values[column.accessorKey]) 
        ? values[column.accessorKey] 
        : [];
      
      // Extract IDs for the select component - handle both {id, title} and {clientDivisionId} formats
      const selectedIds = selectedValues.map(v => v.id || v.clientDivisionId).filter(Boolean);
      
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={column.header}>
              {column.header}
            </InputLabel>
            <Select
              labelId={column.header}
              key={column.accessorKey}
              label={column.header}
              name={column.accessorKey}
              variant="standard"
              required={column.required}
              multiple
              sx={{ width: '360px' }}
              value={selectedIds}
              onChange={(e) => {
                // Convert selected IDs back to objects with id/title format
                const selectedObjects = e.target.value.map(id => 
                  column.options.find(opt => opt.id === id)
                ).filter(Boolean);
                setValues({ ...values, [e.target.name]: selectedObjects });
              }}
            >
              {column.options.map((opt) => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {column.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    return null;
  };

  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    onSubmit(values);
  };

  const chunkedColumns = chunkColumns(columns, 3);

  return (
    <Dialog open={open} fullWidth maxWidth="lg">
      <Box sx={{ padding: 3 }}>
        <Typography variant="h6" sx={{ marginBottom: 2 }}>
          Add New Contact
        </Typography>
        
        {/* Google Places Address Search Section */}
        <AddressAutocompleteSection
          values={values}
          setValues={setValues}
          countriesEnum={countriesEnum}
          provincesEnum={provincesEnum}
        />

        {/* Manual Input Fields */}
        <div className={classes.dialogContentContainer}>
          <Stack
            sx={{
              width: '100%',
              minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
              gap: '1.5rem',
            }}
          >
            {chunkedColumns.map((columnChunk, rowIndex) => (
                <Grid container item spacing={2} key={rowIndex}>
                  {columnChunk.map((column, colIndex) => {
                    if(column.dependentOn && values[column.dependentOn] === column.dependentValue)
                    {
                      return (
                        <Grid item xs={4} key={column.accessorKey}>
                          {renderInput(column, rowIndex * colIndex)}
                        </Grid>
                      );
                    }
                    else {
                      return (
                        <Grid item xs={4} key={column.accessorKey}>
                          {renderInput(column, rowIndex * colIndex)}
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              ))}
          </Stack>
        </div>
      </Box>
      {isLoading && (
        <DialogActions sx={{ p: '1.25rem' }}>
          <Spinner />
        </DialogActions>
      )}
      {!isLoading && (
        <DialogActions sx={{ p: '1.25rem' }}>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button color="primary" sx={{ color: 'white' }} onClick={handleSubmit} variant="contained" disabled={!isDirty}>
            Create
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export { ClientContactsEditRecordModal, ClientContactsCreateRecordModal };

export default compose(
  withStyles(styles)
)(ClientContactsEditRecordModal);
